/**
 * Read and persist the authenticated user's profile in the same browser
 * storage that owns the current auth token.
 *
 * A session started without "Lembrar-me" lives in sessionStorage. Older
 * consumers only read localStorage, which left the sidebar and comment
 * composer with a stale user object (and therefore no current profile photo).
 */

const getStorage = (storage) => {
  if (typeof window === 'undefined') return null;
  try {
    return window[storage];
  } catch (_) {
    return null;
  }
};

export const readStoredUser = () => {
  const local = getStorage('localStorage');
  const session = getStorage('sessionStorage');
  if (!local && !session) return null;

  const candidates = [
    local?.getItem('auth_token') ? local : null,
    session?.getItem('auth_token') ? session : null,
  ].filter(Boolean);

  for (const storage of candidates) {
    try {
      const raw = storage.getItem('user');
      if (raw) return JSON.parse(raw);
    } catch (_) {
      // Try the other storage if this entry is malformed.
    }
  }
  return null;
};

export const persistStoredUser = (user) => {
  if (typeof window === 'undefined' || !user) return;
  const local = getStorage('localStorage');
  const session = getStorage('sessionStorage');
  const target = local?.getItem('auth_token') ? local
    : (session?.getItem('auth_token') ? session : null);

  if (!target) return;
  try {
    target.setItem('user', JSON.stringify(user));
  } catch (_) {
    // Storage can be unavailable in private browsing; memory state still
    // remains the source of truth for the current render.
  }
};

